<img src="/assets/img/cintra-logo.svg" alt="Cintra logo" style="height: 4rem" />
<img src="/assets/img/cloud.svg" alt="Cintra cloud" style="width: 4rem; margin-left: 0.8rem" />
